import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'preptimize-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Preptimize',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 18773846337,
  email: 'support@preptimize.health',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/preptimize/index.js